// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  // serviceUrl: 'http://localhost:20559/Services/Web.svc/',
  //serviceApiUrl: 'http://localhost:20559/Services/General.svc/',
  serviceUrl: 'https://api.segurosmedicosinternacionales.com.co/prod/services/web.svc/',
  apiUpgrade: 'https://embeddedapi.segurosmedicosinternacionales.com.co',
  apipaypal: 'http://desarrollo.segurosmedicosinternacionales.com.co:3000/sandbox/paypal/',
  apiIntermv2: 'https://pruebas.segurosmedicosinternacionales.com.co',
  lealCoinUrl: 'https://coinstest.leal.co/apiexterno/api/comercios/',
  lealCoinUser: 'segurosmedicosi',
  lealCoinPass: '123',
  lealCoinId: '816'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts